import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';

export const geocodeArea = async (area: string, payload?: any): Promise<IAreaLatLng> => {
  const results = await geocodeByAddress(`${area}, Brazil`);
  const latLng = await getLatLng(results[0]);
  return ({ ...latLng, area, payload });
};
